import { DateTime } from 'luxon';
import React from 'react';
import { formatDateWithISOFallback } from 'utils/date-helper';
import { fromISO } from 'utils/luxon-helpers';

interface Props {
  /** Date time string */
  value?: string;
  /** Moment's format */
  format?: string;
  /** Show year, if format IS NOT specified, and year is !== current year */
  formatAutoIncludeYear?: boolean;
}

export const DateTimeFormat: React.FC<Props> = props => {
  const { value, formatAutoIncludeYear = true } = props;
  const format = props.format;

  if (!value) return null;

  if (format) {
    return <>{formatDateWithISOFallback(fromISO(value), format)}</>;
  }

  return (
    <>{fromISO(value).toLocaleString(determineDefaultDateFormat(value, formatAutoIncludeYear))}</>
  );
};

export default DateTimeFormat;

function determineDefaultDateFormat(date: string | undefined, formatAutoIncludeYear: boolean) {
  if (formatAutoIncludeYear && new Date(date!).getFullYear() !== new Date().getFullYear()) {
    return DateTime.DATE_MED_WITH_WEEKDAY;
  }
  return { ...DateTime.DATE_MED_WITH_WEEKDAY, year: undefined };
}
